import './Auth.scss';

import { useAuthForm } from "../hooks/useAuthForm";

import AuthForm from "./components/AuthForm/AuthForm";
import AuthBanner from "./components/AuthBanner/AuthBanner";

const Auth = () => {
    const {formId, handleLogin, loadingStatus} = useAuthForm();

    return (
        <div className={"auth"}>
            <div className={"auth_container"}>
                <div className={"auth_login"}>
                    <AuthForm
                        formId={formId}
                        handleLogin={handleLogin}
                        loadingStatus={loadingStatus}
                    />
                </div>
                <div className={"auth_banner"}>
                    <AuthBanner/>
                </div>
            </div>
        </div>
    )
}

export default Auth;